<div class="o-grid o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.showStep1">
		<form class="o-grid o-grid--wrap" name="vm.form" (ngSubmit)="vm.nextStep()" autocomplete="off" novalidate>
			<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
				<div class="o-grid">
					<div class="o-grid__cell u-no-p">
						<section class="c-section c-section--last"
								[ngClass]="{ 'c-section--error': vm.stepInvalid }"
								panel 
								[isOpen]="true">
							<div class="c-section__header">
								<h2 class="c-section__title c-section__title--sm">{{ 'PreVisit.Symptom_Check.Free_Text_Problem_Description_Title' | translate }}</h2>
							</div>
							<div class="c-section__content">
								<div class="o-grid">
									<div class="o-grid__cell u-no-p@up-to-md">
										<div class="c-card" [ngClass]="{ 'c-card--error': vm.stepInvalid }">
											<div class="c-form" *ngIf="!vm.isSaving">
												<div class="c-content" style="min-height: 100px;">
													<div class="c-form__group u-osb-sm"
														[ngClass]="{ 'c-form__group--error': vm.stepInvalid }">
														<p style="margin-bottom: 15px;">{{ 'PreVisit.Symptom_Check.Free_Text_Problem_Description_Details' | translate }}</p>
														<div [ngClass]="{'c-form__group--error': vm.stepInvalid}">
															<textarea rows="10" id="problemDescription" name="problemDescription" class="c-form__input"
																		 [(ngModel)]="vm.problemDescription" [required]="true">
		                                                    </textarea>
														</div>
													</div>
												</div>
											</div>
											<div style="min-height:200px;" *ngIf="vm.isSaving">
												<loader-overlay></loader-overlay>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
				<div class="o-grid u-ost-md u-osb-md@up-to-md" *ngIf="!vm.isSaving">
					<div class="o-grid__cell o-grid__cell--w-100@up-to-md o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
						<button id="nextStepButton" type="submit" class="c-button c-button--s2 c-button--fit c-button--lg">
							{{'Common.Next' | translate}}
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
	<div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.showStep2">
		<symptom-check-results [interview]="null" [config]="vm.parentCategoryConfig" [problemDescription]="vm.problemDescription"></symptom-check-results>
	</div>
</div>

